export interface MarketingScreenshotAsset {
  label: string;
  src: string;
}

export interface MarketingVideoAsset {
  title: string;
  src: string;
  poster?: string;
}

export const MARKETING_VIDEO_ASSET: MarketingVideoAsset = {
  title: 'IndiEye MVP Walkthrough',
  src: '',
  poster: '/media/videos/indieye-mvp-demo-poster.svg',
};

export const MARKETING_SCREENSHOT_ASSETS: MarketingScreenshotAsset[] = [
  { label: 'Dashboard', src: '/media/screenshots/dashboard.svg' },
  { label: 'Strategy', src: '/media/screenshots/strategy.svg' },
  { label: 'Intelligence', src: '/media/screenshots/intelligence.svg' },
  { label: 'Markets', src: '/media/screenshots/markets.svg' },
  { label: 'Options', src: '/media/screenshots/options.svg' },
  { label: 'Portfolio', src: '/media/screenshots/portfolio.svg' },
  { label: 'Backtest', src: '/media/screenshots/backtest.svg' },
  { label: 'World Monitor', src: '/media/screenshots/world-monitor.svg' },
  { label: 'Settings', src: '/media/screenshots/settings.svg' },
  { label: 'Chat', src: '/media/screenshots/chat.svg' },
];
